import React, { memo } from 'react';
import { CollisionPriority } from '@dnd-kit/abstract';
import { useDroppable } from '@dnd-kit/react';

export const Column = memo(function Column({ children, id, index, label }) {
    const { ref } = useDroppable({
        id,
        type: 'column',
        collisionPriority: CollisionPriority.Low,
        accept: 'item',
    });

    const count = React.Children.count(children);

    return (
        <div
            ref={ref}
            className="board__column flex-none w-[220px] min-h-[420px] stride-surface p-3 flex flex-col gap-2.5 transition-colors"
        >
            <div className="flex items-center justify-between pb-1 px-1 text-xs font-bold uppercase tracking-wider text-stride-heading">
                <span>{label}</span>
                <span className="font-mono text-xs font-semibold px-1.5 py-0.5 rounded-full bg-slate-100 text-gray-500">
                    {count}
                </span>
            </div>
            {children}
        </div>
    );
});
